import { useNavigate, useParams } from 'react-router-dom';
import useChild from '../../hooks/queries/useChild';
import { PROTECTED_PATHS } from '../../navigation/paths';
import { CorrectIcon, ExamsIcon, ListIcon, NotifyIcon, ProgressIcon } from '../svgs/SideBarIcon';
import classNames from './sideBar.module.scss';
import SideBarItem from './sideBarItem/SideBarItem';
import useConversation from '../../hooks/queries/useConversation';
import useAvatars from '@/features/children/hooks/useAvatars';
import { ShoppingCart } from 'lucide-react';

export default function SideBar({
  onClose,
  collapsed = false,
}: {
  onClose?: () => void;
  collapsed?: boolean;
}) {
  const { childId } = useParams<{ childId: string }>();
  const navigate = useNavigate();
  const { data: conversation, refetch } = useConversation();
  const { data: child } = useChild(childId);
  const { data: avatarsData } = useAvatars();

  const selectedAvatar = avatarsData?.icons?.find((a) => a.id === child?.avatarId);
  const avatarUrl = selectedAvatar?.urlPath || child?.avatar.urlPath || '/images/defaultAvatar.png';

  const unSeenMessagesCount: number = conversation?.pages[0].unSeenMessagesCount || 0;
  const notifIcon = (
    <span className={classNames.badgeWrap}>
      <NotifyIcon />
      {unSeenMessagesCount > 0 ? (
        <span className={classNames.badge}>
          {unSeenMessagesCount > 99 ? '99+' : unSeenMessagesCount}
        </span>
      ) : null}
    </span>
  );
  return (
    <div className={`${classNames.container} ${collapsed ? classNames.collapsed : ''}`}>
      {/* Brand mark, pinned above the scrolling menu. Hidden on the collapsed rail, which is
          far too narrow for the wordmark — the navbar shows it there instead. */}
      <button
        type="button"
        className={classNames.logo}
        onClick={() => navigate(PROTECTED_PATHS.children)}
      >
        <img src="/images/logo.webp" alt="ClassQuiz" />
      </button>

      <div className={classNames.content}>
        <div className={classNames.childInfo}>
          <div className={classNames.avatarRing}>
            <img
              className={classNames.avatar}
              src={avatarUrl}
              alt=""
              onError={(e) => {
                e.currentTarget.src = '/images/defaultAvatar.png';
              }}
            />
          </div>
          {child?.fullName ? <div className={classNames.name}>{child.fullName}</div> : null}
        </div>

        <nav className={classNames.nav}>
          <SideBarItem
            title={'تقدم طفلك'}
            icon={<ProgressIcon />}
            forward={PROTECTED_PATHS.childProgress.replace(':childId', String(childId))}
            onClose={onClose}
            collapsed={collapsed}
          />
          <SideBarItem
            title={'إصلاح التمارين'}
            icon={<CorrectIcon />}
            forward={PROTECTED_PATHS.EXERCISES_CORRECTION.build(Number(childId))}
            onClose={onClose}
            collapsed={collapsed}
          />
          <SideBarItem
            title={'قائمة الامتحانات'}
            icon={<ExamsIcon />}
            forward={PROTECTED_PATHS.ListSubjectExams.replace(':childId', String(childId))}
            onClose={onClose}
            collapsed={collapsed}
          />
          <SideBarItem
            title={'دعم العملاء'}
            icon={notifIcon}
            forward={PROTECTED_PATHS.chatSupport.replace(':childId', String(childId))}
            onClose={onClose}
            collapsed={collapsed}
          />
          <SideBarItem
            title={'المتجر'}
            icon={<ShoppingCart size={24} />}
            forward={PROTECTED_PATHS.store.replace(':childId', String(childId))}
            onClose={onClose}
            collapsed={collapsed}
          />
          <SideBarItem
            title={'قائمة أطفالي'}
            icon={<ListIcon />}
            forward={PROTECTED_PATHS.children}
            onClose={onClose}
            collapsed={collapsed}
          />
        </nav>
      </div>
    </div>
  );
}
